import { Link } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { MouseEvent } from 'react';

import { Func } from '@/utils/ts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondary: {
      color: theme.colors.primary,
    },
  }),
);

export interface ButtonLinkProps {
  'data-test'?: string;
  type?: 'primary' | 'secondary';
  onClick: Func;
  className?: string;
  style?: React.CSSProperties;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({
  className,
  style,
  onClick,
  type = 'primary',
  'data-test': dataTest,
  children,
}) => {
  const classes = useStyles();
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      data-test={dataTest}
      variant="body1"
      component="button"
      className={clsx(className, type === 'secondary' && classes.secondary)}
      onClick={async (e: MouseEvent): Promise<void> => {
        e.preventDefault();
        onClick();
      }}
      style={style}
    >
      {children}
    </Link>
  );
};

export default ButtonLink;
